<template>
  <div v-loading="loading">

    <div class="product-items-container" v-loading="tableLoading">
      <table
        class="product-items-table"
        cellpadding="0"
        cellspacing="0"
      >
        <table-header
          :price-types="priceTypes"
        />
        <tbody>
          <table-row
            v-for="product in products"
            ref="row"
            :key="product.id"
            :default-product="product"
            :price-types="priceTypes"
            :normal-price="normalPrice"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import TableHeader from './TableHeader';
import TableRow from './TableRow';

export default {
  components: {
    TableHeader,
    TableRow,
  },
  data() {
    return {
      loading: false,
      priceTypes: [],
      normalPrice: {},
    };
  },
  computed: {
    products() {
      return this.$store.getters['representativePrice/representativePrices'];
    },
    tableLoading() {
      return this.$store.getters['representativePrice/loading'];
    }
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch('representativePrice/fetchAll');
    this.priceTypes = await axios.get('api/price-types');
    this.normalPrice = this.priceTypes.find(pt => pt.is_base_price);
    this.loading = false;
  },
  methods: {
    reCalculate() {
      this.$refs['row'].forEach(rowRef => {
        rowRef.reCalculate();
      });
    },
    getItems() {
      const items = [];
      this.$refs['row'].forEach(row => items.push(...row.getPrice()));
      return items;
    },
  },
};
</script>

<style lang="scss">
  $borderColor: #EBEEF5;
  $headerColor: #909399;

  .product-items-container {
    .product-items-table {
      border-left: 1px solid $borderColor;
      border-top: 1px solid $borderColor;
      width: 100%;

      td {
        border-right: 1px solid $borderColor;
        border-bottom: 1px solid $borderColor;
        padding: 12px 10px;
        margin-bottom: -1px;
        vertical-align: top;
        font-size: 14px;
      }

      .product-items-table__header {
        color: $headerColor;
        font-size: 14px;
        font-weight: bold;
      }

      .product-items-table__body {
      }
    }

    .add-item {
      border-bottom: 1px dotted #dadfe7;
      border-left: 1px dotted #dadfe7;
      border-right: 1px dotted #dadfe7;
      text-align: center;
      padding: 10px;
    }
  }

</style>
